(() => {
  const story = document.querySelector('[data-lamp-story]');
  if (!story) return;
  const nav = story.querySelector('.nl-nav');
  const header = document.querySelector('[data-site-header]');
  const links = [...story.querySelectorAll('.nl-nav-links a')];
  const navLinks = story.querySelector('.nl-nav-links');
  let previousActive = -1, previousNavWidth = -1;
  const targets = links.map(link => document.getElementById(link.hash.slice(1)));
  let scheduled = false;
  let previousOffset = -1;
  let previousHeight = -1;
  const update = () => {
    scheduled = false;
    const headerRect = header?.getBoundingClientRect();
    const offset = headerRect && headerRect.top <= 1 ? Math.max(0, headerRect.bottom) : 0;
    const navHeight = nav.getBoundingClientRect().height;
    const rect = story.getBoundingClientRect();
    if (offset !== previousOffset) {
      story.style.setProperty('--nl-header', `${offset}px`);
      previousOffset = offset;
    }
    if (navHeight !== previousHeight) {
      story.style.setProperty('--nl-nav-height', `${navHeight}px`);
      previousHeight = navHeight;
    }
    const travelled = Math.max(0, offset - rect.top);
    const distance = Math.max(1, rect.height - window.innerHeight + offset);
    story.style.setProperty('--nl-progress', Math.min(1, travelled / distance).toFixed(4));
    let active = 0;
    targets.forEach((target, index) => {
      if (target && target.getBoundingClientRect().top <= offset + navHeight + 60) active = index;
    });
    links.forEach((link, index) => {
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    // Scroll only the label strip, never the page, when the active chapter changes.
    const navWidth = navLinks.clientWidth;
    if (active !== previousActive || navWidth !== previousNavWidth) {
      previousActive = active;
      previousNavWidth = navWidth;
      const current = links[active];
      if (current && navWidth && navLinks.scrollWidth > navWidth) {
        const strip = navLinks.getBoundingClientRect();
        const label = current.getBoundingClientRect();
        const left = label.left - strip.left - 12;
        const right = label.right - strip.right + 12;
        const delta = label.width > navWidth - 24 ? left : left < 0 ? left : right > 0 ? right : 0;
        if (delta) navLinks.scrollBy({
          left: delta,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    observer.observe(nav);
    if (header) observer.observe(header);
  }
  update();

  // Illustration only: these controls do not change a purchasable variant.
  story.querySelectorAll('.nl-light_lab').forEach(lab => {
    const stage = lab.querySelector('[data-light-stage]');
    const buttons = [...lab.querySelectorAll('[data-lamp-tone]')];
    const range = lab.querySelector('[data-lamp-brightness]');
    lab.querySelector('fieldset').disabled = false;
    range.disabled = false;
    buttons.forEach(button => button.addEventListener('click', () => {
      stage.dataset.tone = button.dataset.lampTone;
      buttons.forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    }));
    const setBrightness = () => {
      const level = Math.max(1, Math.min(3, Math.round(Number(range.value))));
      range.value = String(level);
      // Low and medium preserve the previous medium and high appearances.
      stage.style.setProperty('--nl-power', String(level === 1 ? 2 / 3 : 1));
      stage.style.setProperty('--nl-boost', String(level === 3 ? 1.45 : 1));
      stage.style.setProperty('--nl-glow-radius', level === 3 ? '22px' : '12px');
    };
    range.addEventListener('input', setBrightness);
    setBrightness();
  });

  // Text is visible by default: no hidden sections waiting for JavaScript.
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveals = [...story.querySelectorAll('[data-lamp-reveal]')];
  let observer;
  const configureMotion = () => {
    observer?.disconnect();
    reveals.forEach(item => item.classList.remove('nl-enter'));
    if (preference.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nl-enter');
        observer.unobserve(entry.target);
      });
    }, {threshold:.08, rootMargin:'0px 0px -24px 0px'});
    reveals.forEach(item => {
      if (item.getBoundingClientRect().top > window.innerHeight) observer.observe(item);
    });
  };
  configureMotion();
  preference.addEventListener('change', configureMotion);
})();
